import {
    useEffect,
    useState
} from "react";

import {
    Link,
    useNavigate
} from "react-router-dom";

import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function Suppliers() {

    const navigate =
        useNavigate();

    const [suppliers,
        setSuppliers] =
        useState([]);

    const [page,
        setPage] =
        useState(1);

    const [pages,
        setPages] =
        useState(1);

    const [search,
        setSearch] =
        useState("");

    useEffect(() => {
        loadSuppliers();
    }, [page, search]);

    const loadSuppliers =
        async () => {


            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                const res =
                    await API.get(
                        `/suppliers?page=${page}&search=${search}`,
                        {
                            headers: {
                                Authorization:
                                    `Bearer ${token}`
                            }
                        }
                    );

                setSuppliers(
                    res.data.suppliers || []
                );

                setPages(
                    res.data.pages || 1
                );

            } catch (err) {
                console.log(err);
            }

        };

    const deleteSupplier =
        async (id) => {
            if (
                !window.confirm(
                    "Delete Supplier?"
                )
            ) return;

            try {

                const token =
                    localStorage.getItem(
                        "adminToken"
                    );

                await API.delete(
                    `/suppliers/${id}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`
                        }
                    }
                );

                loadSuppliers();

            } catch (err) {
                console.log(err);
            }

        };


    return (<div className="w-full">


        <div
            className="
    flex
    flex-col
    md:flex-row
    md:items-center
    md:justify-between
    gap-4
    mb-6
  "
        >

            <h1
                className="
      text-3xl
      md:text-4xl
      font-bold
    "
            >
                Suppliers
            </h1>

            {hasPermission("supplier.view") && (
                <Link
                    to="/admin/suppliers/add"
                    className="
      px-5
      py-3
      bg-yellow-500
      text-black
      rounded-xl
      font-semibold
      text-center
    "
                >
                    Add Supplier
                </Link>
            )}

        </div>

        <input
            value={search}
            onChange={(e) =>
                setSearch(
                    e.target.value
                )
            }
            placeholder="Search Supplier..."
            className="
    w-full
    md:w-96
    p-3
    rounded-xl
    bg-[#111]
    border
    border-yellow-500/20
    mb-6
    outline-none
  "
        />

        {/* MOBILE */}

        <div className="md:hidden space-y-4">

            {suppliers.map(
                (item) => (

                    <div
                        key={item.id}
                        className="
          bg-[#111]
          rounded-2xl
          p-4
          border
          border-yellow-500/10
        "
                    >

                        <div className="flex justify-between">
                            <span>ID</span>
                            <span>{item.id}</span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>Name</span>
                            <span>{item.supplier_name}</span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>Phone</span>
                            <span>{item.phone}</span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>Email</span>
                            <span>{item.email}</span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>GST</span>
                            <span>{item.gst_no}</span>
                        </div>

                        <div className="flex justify-between mt-2">
                            <span>Status</span>

                            <span
                                className={
                                    Number(item.status) === 1
                                        ? "text-green-500"
                                        : "text-red-500"
                                }
                            >
                                {Number(item.status) === 1
                                    ? "Active"
                                    : "Inactive"}
                            </span>

                        </div>

                        <div className="flex gap-2 mt-4">
                            {hasPermission("supplier.edit") && (
                                <button
                                    onClick={() =>
                                        navigate(
                                            `/admin/suppliers/edit/${item.id}`
                                        )
                                    }
                                    className="
              flex-1
              py-2
              bg-blue-500
              rounded-lg
            "
                                >
                                    Edit
                                </button>
                            )}

                            {hasPermission("supplier.delete") && (
                                <button
                                    onClick={() =>
                                        deleteSupplier(
                                            item.id
                                        )
                                    }
                                    className="
              flex-1
              py-2
              bg-red-500
              rounded-lg
            "
                                >
                                    Delete
                                </button>
                            )}

                        </div>

                    </div>

                )
            )}

        </div>

        {/* DESKTOP */}

        <div
            className="
    hidden
    md:block
    bg-[#111]
    rounded-2xl
    overflow-hidden
  "
        >

            <div className="overflow-x-auto">

                <table className="w-full">

                    <thead>

                        <tr
                            className="
            border-b
            border-yellow-500/20
          "
                        >
                            <th className="p-4 text-left">
                                ID
                            </th>

                            <th className="p-4 text-left">
                                Supplier
                            </th>

                            <th className="p-4 text-left">
                                Phone
                            </th>

                            <th className="p-4 text-left">
                                Email
                            </th>

                            <th className="p-4 text-left">
                                GST No
                            </th>

                            <th className="p-4 text-center">
                                Status
                            </th>

                            <th className="p-4 text-center">
                                Action
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {suppliers.map(
                            (item) => (

                                <tr
                                    key={item.id}
                                    className="
                border-b
                border-yellow-500/10
              "
                                >

                                    <td className="p-4">
                                        {item.id}
                                    </td>

                                    <td className="p-4">
                                        {item.supplier_name}
                                    </td>

                                    <td className="p-4">
                                        {item.phone}
                                    </td>

                                    <td className="p-4">
                                        {item.email}
                                    </td>

                                    <td className="p-4">
                                        {item.gst_no}
                                    </td>

                                    <td className="p-4 text-center">

                                        <span
                                            className={
                                                Number(item.status) === 1
                                                    ? "text-green-500"
                                                    : "text-red-500"
                                            }
                                        >
                                            {Number(item.status) === 1
                                                ? "Active"
                                                : "Inactive"}
                                        </span>

                                    </td>

                                    <td className="p-4">

                                        <div
                                            className="
                    flex
                    justify-center
                    gap-2
                  "
                                        >

                                            {hasPermission("supplier.edit") && (
                                                <button
                                                    onClick={() =>
                                                        navigate(
                                                            `/admin/suppliers/edit/${item.id}`
                                                        )
                                                    }
                                                    className="
                      px-4
                      py-2
                      bg-blue-500
                      rounded-lg
                    "
                                                >
                                                    Edit
                                                </button>
                                            )}

                                            {hasPermission("supplier.delete") && (
                                                <button
                                                    onClick={() =>
                                                        deleteSupplier(
                                                            item.id
                                                        )
                                                    }
                                                    className="
                      px-4
                      py-2
                      bg-red-500
                      rounded-lg
                    "
                                                >
                                                    Delete
                                                </button>
                                            )}

                                        </div>

                                    </td>

                                </tr>

                            )
                        )}

                    </tbody>

                </table>

            </div>

        </div>

        {/* PAGINATION */}

        <div className="flex gap-2 mt-6 flex-wrap">

            <button
                disabled={page === 1}
                onClick={() =>
                    setPage(page - 1)
                }
                className="
      px-4
      py-2
      bg-[#111]
      rounded-lg
    "
            >
                Back
            </button>

            {[...Array(pages)].map(
                (_, i) => (
                    <button
                        key={i}
                        onClick={() =>
                            setPage(i + 1)
                        }
                        className={`
            px-4
            py-2
            rounded-lg
            ${page === i + 1
                                ? "bg-yellow-500 text-black"
                                : "bg-[#111]"
                            }
          `}
                    >
                        {i + 1}
                    </button>
                )
            )}

            <button
                disabled={page === pages}
                onClick={() =>
                    setPage(page + 1)
                }
                className="
      px-4
      py-2
      bg-[#111]
      rounded-lg
    "
            >
                Next
            </button>

        </div>

    </div>

    );
}

export default Suppliers;
